import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, CheckCircle2, Clock, ArrowUpRight } from "lucide-react";
import api from "@/lib/api";

function Stat({ label, value, icon: Icon }) {
  return (
    <div className="bg-white border border-[var(--brdr)] rounded-sm p-7 shadow-sm">
      <div className="flex items-center justify-between">
        <span className="overline">{label}</span>
        <Icon className="h-5 w-5 text-gold" strokeWidth={1.5} />
      </div>
      <div className="font-serif text-5xl text-oxford mt-4">{value}</div>
    </div>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="overline mb-2">Overview</div>
      <h1 className="font-serif text-4xl text-oxford tracking-tight">Dashboard</h1>

      <div className="grid sm:grid-cols-3 gap-6 mt-8">
        <Stat label="Completed Assessments" value={stats?.total_assessments ?? "—"} icon={CheckCircle2} />
        <Stat label="Total Leads" value={stats?.total_leads ?? "—"} icon={Users} />
        <Stat label="In Progress" value={stats?.in_progress ?? "—"} icon={Clock} />
      </div>

      <div className="bg-white border border-[var(--brdr)] rounded-sm shadow-sm mt-8">
        <div className="p-6 border-b border-[var(--brdr)] flex items-center justify-between">
          <h3 className="font-serif text-xl text-oxford">Recent Submissions</h3>
          <button onClick={() => navigate("/admin/submissions")} data-testid="view-all-btn"
            className="text-xs uppercase tracking-[0.15em] text-[var(--text2)] hover:text-oxford flex items-center gap-1">
            View all <ArrowUpRight className="h-3 w-3" />
          </button>
        </div>
        <div className="divide-y divide-[var(--brdr)]">
          {stats?.recent?.length ? stats.recent.map((r) => (
            <button key={r.assessment_id} onClick={() => navigate(`/admin/submissions/${r.assessment_id}`)}
              data-testid={`recent-${r.assessment_id}`}
              className="w-full text-left px-6 py-4 flex items-center justify-between hover:bg-alabaster transition-colors">
              <div>
                <div className="text-sm font-medium text-oxford">{r.name}</div>
                <div className="text-xs text-[var(--text2)]">{r.company} · {r.sector}</div>
              </div>
              <div className="flex items-center gap-6 font-mono text-sm">
                <span className="text-oxford">B {r.business_score?.toFixed(1) ?? "—"}</span>
                <span className="text-gold">L {r.legacy_score?.toFixed(1) ?? "—"}</span>
              </div>
            </button>
          )) : <div className="px-6 py-10 text-center text-sm text-[var(--text2)]">No submissions yet.</div>}
        </div>
      </div>
    </div>
  );
}
